import { FunctionComponent, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import './ViewLocation.scss';
import ButtonField from '../../Components/Button/ButtonField';
import { useNavigate, useParams } from 'react-router-dom';
import { ILocationList, MastersProps } from './ILocation';
import { getOneLocation } from '../../Redux/Slicers/Location/GetOneLocationSlicer copy';

interface WorkingTime {
  open: boolean;
  start: string;
  end: string;
}

interface LocationData {
  location_name: string;
  location_address: string;
  location_lat: number;
  location_long: number;
  location_landmark: string;
  total_ordinary_slot: number;
  total_vip_slot: number;
  available_vip_slot: number;
  available_ordinary_slot: number;
  ads_type: {
    title: string;
    description: string;
    image: string;
    link: string;
  };
  garage_images: string[];
  status: boolean;
  working_hours: {
    [key: string]: WorkingTime;
  };
  // membership_price: 0;
  // membership_description: "";
  minimum_billing_time_unit: string;
  grace_time: string;
}

const ViewLocation: FunctionComponent<MastersProps> = () => {
  const dispatch = useAppDispatch();
  const { id }: any = useParams();

  useEffect(() => {
    dispatch(getOneLocation(id));
  }, []);
  const nav = useNavigate();
  const { data: GetOneLocation } = useAppSelector(
    (state) => state?.GetOneLocation
  );

  const locationData = GetOneLocation?.response
    ?.data as unknown as LocationData;

  return (
    <div className="Location_view_main_container">
      <div className="Location_view_container">
        <div className="Location_view_schedule_card">
          <p className="view_card_title">Location Details</p>
          <div className="view_schedule_contant">
            <table className="table">
              <tbody>
                <tr>
                  <th>Location Name</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.location_name}
                  </td>
                </tr>
                <tr>
                  <th>Address</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.location_address}
                  </td>
                </tr>
                <tr>
                  <th>Latitude</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.location_lat}
                  </td>
                </tr>
                <tr>
                  <th>Longitude</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.location_long}
                  </td>
                </tr>
                <tr>
                  <th>Landmark</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.location_landmark}
                  </td>
                </tr>
                <tr>
                  <th>Minimum Billing Time Unit</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.minimum_billing_time_unit}
                  </td>
                </tr>
                <tr>
                  <th>Grace Time</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.grace_time}
                  </td>
                </tr>
                {/* <tr>
                  <th>Membership Price</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.membership_price}
                  </td>
                </tr>
                <tr>
                  <th>Membership Description</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.membership_description}
                  </td>
                </tr> */}
                {/*   <tr>
               <th>Total Ordinary Slot</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.total_ordinary_slot}
                  </td>
                </tr>
                <tr>
                  <th>Total VIP Slot</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.total_vip_slot}
                  </td>
                </tr> 
                 <tr>
                  <th>Available VIP Slots</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.available_vip_slot}
                  </td>
                </tr>
                <tr>
                  <th>Available Ordinary Slots</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.available_ordinary_slot}
                  </td>
                </tr> */}
                <tr>
                  <th>Ads Title</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.ads_type?.title}
                  </td>
                </tr>
                <tr>
                  <th>Ads Description</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.ads_type?.description}
                  </td>
                </tr>

                <tr>
                  <th>Ads Link</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.ads_type?.link && (
                      <a
                        href={locationData.ads_type.link}
                        target="_blank"
                        rel="noopener noreferrer">
                        {locationData.ads_type.link}
                      </a>
                    )}
                  </td>
                </tr>
                <tr>
                  <th>Ads Image </th>
                  <td>
                    : &nbsp;&nbsp;&nbsp;&nbsp;
                    <img
                      src={`${process.env.REACT_APP_API_URL}/${locationData?.ads_type?.image}`}
                      alt="Ad Image"
                      style={{
                        maxWidth: "200px",
                        height: "auto",
                        maxHeight: "200px",
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <th>Hourly Rate</th>
                  <td>:&nbsp;&nbsp;&nbsp;&nbsp;{(locationData as any)?.hourly_rate ?? "-"}</td>
                </tr>
                <tr>
                  <th>Square Logo</th>
                  <td>
                    : &nbsp;&nbsp;&nbsp;&nbsp;
                    {(locationData as any)?.square_logo_url && (
                      <img
                        src={`${process.env.REACT_APP_API_URL}/${(locationData as any).square_logo_url}`}
                        alt="Square Logo"
                        style={{ maxWidth: "100px", height: "auto", maxHeight: "100px" }}
                      />
                    )}
                  </td>
                </tr>
                <tr>
                  <th>Horizontal Logo</th>
                  <td>
                    : &nbsp;&nbsp;&nbsp;&nbsp;
                    {(locationData as any)?.logo_url && (
                      <img
                        src={`${process.env.REACT_APP_API_URL}/${(locationData as any).logo_url}`}
                        alt="Horizontal Logo"
                        style={{ maxWidth: "200px", height: "auto", maxHeight: "100px" }}
                      />
                    )}
                  </td>
                </tr>
                <tr>
                  <th>Garage Images</th>
                  <td>
                    {/* :&nbsp;&nbsp;&nbsp;&nbsp; */}
                    {Array.isArray(locationData?.garage_images) ? (
                      locationData.garage_images.map((image, index) => {
                        const imageUrl = `${process.env.REACT_APP_API_URL}/${image}`;
                        console.log(`Loading image: ${imageUrl}`); // Debugging line
                        return (
                          <img
                            key={index}
                            src={imageUrl}
                            alt={`Garage Image ${index + 1}`}
                            style={{
                              maxWidth: "200px",
                              height: "auto",
                              marginRight: "10px",
                              maxHeight: "200px",
                            }}
                          />
                        );
                      })
                    ) : (
                      <span>No garage images available</span>
                    )}
                  </td>
                </tr>
                <tr>
                  <th>Status</th>
                  <td>
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {locationData?.status ? "Active" : "Deactive"}
                  </td>
                </tr>
                <tr>
                  <th>Working Time</th>
                  <td>
                    {/* :&nbsp;&nbsp;&nbsp;&nbsp; */}
                    <table>
                      <tbody>
                        {locationData?.working_hours &&
                          Object.entries(locationData.working_hours).map(
                            ([day, time], index) => (
                              <tr key={index}>
                                <th>
                                  {day.charAt(0).toUpperCase() + day.slice(1)}
                                </th>
                                <td>
                                  :&nbsp;&nbsp;&nbsp;&nbsp;
                                  {time.open
                                    ? `${time.start} - ${time.end}`
                                    : "Closed"}
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <ButtonField onClick={() => nav(-1)}>Back</ButtonField>
    </div>
  );
};

export default ViewLocation;
